// 2P AI — riga sessione (§8.1/§8.4): pastiglia stato, titolo, contesto, tag modello (mono), tempo,
// pulsante chiudi sulle aperte, freccia. La riga in "Attende OK" è evidenziata (waitrow).
import type { ReactNode } from 'react';
import { StatusPill } from './StatusPill';
import { Icon } from './Icon';
import { onCardKey } from '../lib/a11y';
import { ago } from '../lib/time';
import type { SessionSummary } from '../lib/types';

export function SessionRow({ session, where, onOpen, onClose, showClose, onDelete }: {
  session: SessionSummary;
  where?: ReactNode;
  onOpen: () => void;
  onClose?: () => void;
  showClose?: boolean;
  onDelete?: () => void;
}) {
  const wait = session.status === 'awaiting_approval';
  return (
    <div className={wait ? 'srow waitrow' : 'srow'} role="button" tabIndex={0} onClick={onOpen} onKeyDown={onCardKey(onOpen)}>
      <div className="stat"><StatusPill status={session.status} /></div>
      <div className="body">
        <div className="title">{session.title ?? session.id.slice(0, 8)}</div>
        {where != null ? <div className="where">{where}</div> : null}
      </div>
      <div className="right">
        <span className="model">{session.model}</span>
        <span className="ago">{ago(session.created_at)}</span>
        {showClose && onClose ? (
          <button
            className="stop"
            type="button"
            title="Chiudi sessione"
            aria-label="Chiudi sessione"
            onClick={(e) => { e.stopPropagation(); onClose(); }}
          >
            <Icon name="stop_circle" />
          </button>
        ) : null}
        {onDelete ? (
          <button
            className="del"
            type="button"
            title="Elimina sessione"
            aria-label="Elimina sessione"
            onClick={(e) => { e.stopPropagation(); onDelete(); }}
          >
            <Icon name="delete" />
          </button>
        ) : null}
        <span className="go"><Icon name="chevron_right" /></span>
      </div>
    </div>
  );
}
